import { render, staticRenderFns } from "./DriverEditPage.vue?vue&type=template&id=0fa680fd&"
import script from "./DriverEditPage.vue?vue&type=script&lang=js&"
export * from "./DriverEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports